import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import { TableCell } from '@applyboard/ui-components';
import { EligibilityIcon, EligibilityContainer } from "./EligibilityIcon";
function convertString(original) {
  if (typeof original !== 'string') return original;
  return original.replace(/_/g, ' ');
}
var ScoreResult = function ScoreResult(_ref) {
  var applicantHas = _ref.applicantHas,
    requirementMet = _ref.requirementMet,
    requires = _ref.requires;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TableCell, null, convertString(requires)), /*#__PURE__*/React.createElement(TableCell, {
    style: {
      color: requirementMet === false ? 'red' : 'inherit'
    }
  }, requirementMet !== undefined ? /*#__PURE__*/React.createElement(EligibilityIcon, {
    pass: requirementMet
  }) : /*#__PURE__*/React.createElement(EligibilityContainer, null), /*#__PURE__*/React.createElement("span", null, convertString(applicantHas))));
};
export default ScoreResult;